import React from "react";
import { Card, Stack, Text } from "@mantine/core";
import { TbPackageOff } from "react-icons/tb";

export const EmptyRoomDevicesState: React.FC = () => {
  return (
    <Card padding="lg" radius="md" withBorder style={{ height: "100%" }}>
      <Stack align="center" justify="center" gap="xs" style={{ height: "100%" }}>
        <TbPackageOff size={34} opacity={0.6} />

        <Text fw={600} size="md" ta="center">
          Ingen komponenter i dette rommet ennå
        </Text>

        <Text c="dimmed" size="sm" ta="center" maw={360}>
          Bruk knappene over for å legge til komponenter.
        </Text>
      </Stack>
    </Card>
  );
};
